<template>
  <div id="app">
    <!--<img src="./assets/loginbg.png">-->
    <router-view/>
  </div>
</template>

<script>
import { getAction } from '@/utils'

export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {
    actions() {
      return this.$store.getters.actions
    },
    appealAction() {
      return getAction(this.actions, 1111111)
    },
    agencyAction() {
      return getAction(this.actions, 1111112)
    },
    purchaseAction() {
      return getAction(this.actions, 1111121)
    },
    saleAction() {
      return getAction(this.actions, 1111122)
    },
    // 交易流程提醒所需 ------ start
    signatureAction() {
      return getAction(this.actions, 111113222)
    },
    stampAction() {
      return getAction(this.actions, 111113223)
    },
    financeAction() {
      return getAction(this.actions, 111113224)
    },
    approvalAction() {
      return getAction(this.actions, 111113225)
    },
    riskControlAction() {
      return getAction(this.actions, 111113226)
    },
    storeSignature() {
      if (this.signatureAction.IsPermit) {
        return this.getStatus(51)
      }
      return false
    },
    storeStamp() {
      if (this.stampAction.IsPermit) {
        return this.getStatus(52)
      }
      return false
    },
    storeFinance() {
      if (this.financeAction.IsPermit) {
        return this.getStatus(52)
      }
      return false
    },
    storeApproval() {
      if (this.approvalAction.IsPermit) {
        return this.getStatus(52)
      }
      return false
    },
    storeRiskControl() {
      if (this.riskControlAction.IsPermit) {
        return this.getStatus(52)
      }
      return false
    },
    // 交易流程提醒所需 ------ end
    storeFinancial() {
      let financial = 0
      if (this.appealAction.IsPermit) {
        financial += this.$store.getters.newAppealStatus + this.$store.getters.newUnAppealStatus
      }
      if (this.agencyAction.IsPermit) {
        financial += this.$store.getters.newAgencyStatus + this.$store.getters.newUnAgencyStatus
      }
      return financial
    },
    storePurchaseAndSale() {
      let purchaseAndSale = 0
      if (this.purchaseAction.IsPermit) {
        purchaseAndSale += this.$store.getters.newPurchaseStatus
      }
      if (this.saleAction.IsPermit) {
        purchaseAndSale += this.$store.getters.newSaleStatus
      }
      return purchaseAndSale
    }
  },
  watch: {
    storeFinancial: {
      handler(newVal, oldVal) {
        if (newVal >= oldVal) {
          this.$message({
            showClose: true,
            message: '有新的期货代理金融信息',
            type: 'success',
            duration: 0,
            offset: 20
          })
        }
      }
    },
    storePurchaseAndSale: {
      handler(newVal, oldVal) {
        if (newVal >= oldVal) {
          this.$message({
            showClose: true,
            message: '有新的现货代理采销信息',
            type: 'success',
            duration: 0,
            offset: 60
          })
        }
      }
    },
    storeSignature(val) {
      if (val) {
        this.$message({
          showClose: true,
          message: '有新的合同需要签字',
          type: 'success',
          duration: 0,
          offset: 100
        })
      }
    },
    storeStamp(val) {
      if (val) {
        this.$message({
          showClose: true,
          message: '有新的合同需要盖章',
          type: 'success',
          duration: 0,
          offset: 100
        })
      }
    },
    storeFinance(val) {
      if (val) {
        this.$message({
          showClose: true,
          message: '有新的财务步骤等你通过',
          type: 'success',
          duration: 0,
          offset: 100
        })
      }
    },
    storeApproval(val) {
      if (val) {
        this.$message({
          showClose: true,
          message: '有新的审批流程等你通过',
          type: 'success',
          duration: 0,
          offset: 100
        })
      }
    },
    storeRiskControl(val) {
      if (val) {
        this.$message({
          showClose: true,
          message: '有新的风控流程等你通过',
          type: 'success',
          duration: 0,
          offset: 100
        })
      }
    }
  },
  created() {
    // 实现轮询
    this.timer = window.setInterval(() => {
      setTimeout(this.getList, 0)
      setTimeout(this.getRedDot, 0)
    }, 600000)
  },
  methods: {
    getList() {
      this.$store.dispatch('GetTaskNewNotes', {
        UserID: this.$store.getters.name
      }).then(() => {}).catch(err => {
        console.log(JSON.stringify(err))
        clearInterval(this.timer)
      })
    },
    getRedDot() {
      this.$store.dispatch('GetRedDot', {
        UserID: this.$store.getters.userid
      }).then(() => {}).catch(err => {
        console.log(JSON.stringify(err))
        clearInterval(this.timer)
      })
    },
    getStatus(type) {
      const temp = this.$store.getters.accountingRedDot.filter(v => {
        return v.Type === type
      })
      return temp && temp.length > 0 ? temp[0].Status === 1 : false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue